<template>
  <div>
    <b-card 
      v-show="resettingpassword==false"
      class="mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <b-card-title>
        <div
          class="col-12 pt-4 pb-4 text-center"
          :class="gdqmodeclass"
          style="color: white;"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width=320
            alt="GDQ Logo"
          />
        </div>
        <div
          class="col-12 pt-4 pb-4 bg-primary text-center"
          style="color: white;"
        >
          <h2>Administration</h2>
        </div>
      </b-card-title>
      <b-alert
        :show="passwordhasbeenreset"
        variant="success"
      >
        {{ message }}
      </b-alert>
      <b-form @submit.prevent="login">
        <b-form-group 
          label="Enter your username"
          :state="i_name_valid"
          invalid-feedback="User name or password incorrect"
        >
          <b-form-input v-model="i_name" :class="`${anon ? 'g-anon' : '' }`">
          </b-form-input>
        </b-form-group>
        <b-form-group 
          label="Enter your password"
          :state="i_password_valid"
          invalid-feedback="User name or password incorrect"
        >
          <b-form-input  v-model="i_password" type="password">
          </b-form-input>
        </b-form-group>
        <b-row>
          <div class="col-12 mx-auto text-center">
            <b-button
              class="col-12 col-sm-6"
              type="submit"
              variant="primary"
            >
              <b-spinner small class="mr-2 py-0" v-show="loading==true"/>
              <span class="icon-key mr-2" />Login
            </b-button>
          </div>
        </b-row>
        <div class="col-12 mx-auto mt-2 text-center">
          Do you want to change your password? Click <a
            href="javascript: return false"
            @click.prevent="resetpassword"
          >here</a> to reset it.
        </div>
      </b-form>
    </b-card>
    <b-card
      v-show="resettingpassword==true"
      class="mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <b-card-title>
        <div
          class="col-12 pt-4 pb-4 bg-primary text-center"
          style="color: white;"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          >
        </div>
      </b-card-title>
      <h4>Reset password</h4>
    <b-form @submit.prevent="sendpasswordlink">
      <b-form-group
        label="Enter your e-mail address"
        invalid-feedback="Invalid e-mail address"
      >
        <b-form-input
          v-model="passwordemail"
          :state="passwordemail_valid"
        />
      </b-form-group>
      <b-row>
        <div class="col-12 col-lg-5 text-left pb-4">
          <b-button
            lass="col-12"
            type="submit"
            variant="default"
            @click.prevent="resettingpassword=false"
          >
            <span class="mr-2" />Back to login
          </b-button>
        </div>
        <div class="col-12 col-lg-7 text-right">
          <b-button
            class="col-12"
            type="submit"
            variant="primary"
            @click.prevent="sendpasswordlink"
          >
            <span class="icon-key mr-2" />Send me the link!
          </b-button>
        </div>
      </b-row>
    </b-form>
  </b-card>
  </div>
</template>
<script>
import { config } from '../../config'
export default {
  name: 'Login',
  components: {
  },
  data() {
    return {
      gdqmodeclass: (config.mode == 'live') ? 'bg-primary' : config.mode == 'stage' ? 'bg-warning' : 'bg-danger', 
      i_name: "",
      i_name_valid: true,
      i_password: "",
      i_password_valid: true,
      resettingpassword: false,
      passwordhasbeenreset: false,
      message: '',
      passwordemail: '',
      passwordemail_valid: null,
      loading: false,
      goto: this.$store.state.routeafterlogin,
    }
  },
  computed: {
    anon: function() {
      return this.$store.state.anon;
    },
  },
  methods: {
    sendpasswordlink () {
      var formok = true;
      // eslint-disable-next-line
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.passwordemail) == false) {
        formok = false
      }
      if (!formok) {
        this.passwordemail_valid = false
      }
      // -----------------------------------------------
      // Look up whether we have a user for this e-mail
      // -----------------------------------------------
      var filter = {
        email: {
          operator: '=',
          value: this.passwordemail
        }
      }
      this.$store.dispatch('forgotpassword', { filter: filter })
        .then((resp) => {
          var status = resp.status
          this.passwordhasbeenreset = false
          this.message = ''
          if (status == 'OK') {
            this.passwordhasbeenreset = true
            this.message = 'An e-mail has been sent to ' + this.passwordemail + '. Please follow the instructions in the e-mail to reset your password.'
          }
          this.resettingpassword = false
        })
    },
    resetpassword () {
      this.resettingpassword = true
    },
    login: function() {
      this.loading = true;
      const i_name = this.i_name;
      const i_password = this.i_password;
      const admin = 1;
      this.$store.dispatch('login',{i_name,i_password,admin })
      .then(()=> {
        this.loading = false;
        this.$store.commit('setrouteafterlogin','')
        this.$router.push(this.goto ? this.goto : '/')}
      )
      .catch(err => {
        console.log(err);
        this.loading = false;        
        this.i_name_valid = false;
        this.i_password_valid = false;
      });
    }
  }
}
</script>
